<app-loader [enable]="loading">
  <div class="row-container" [ngClass]="{ favorite: report.isFavorite$ | async, disabled: !(report.parameters$ | async) }">
    <div class="report-drag-container">
      <mat-icon class="drag-icon"
                [ngClass]="{ disabled: lockDrag }"
                (mouseenter)="onDragActive.emit(true)"
                (mouseleave)="onDragActive.emit(false)">drag_indicator</mat-icon>
    </div>
    <div class="report-icon-container">
      <mat-icon class="report-icon" [ngStyle]="{ color: badgeColors[report.payload.attributes.report_type] }">{{ report.payload.attributes.report_icon }}</mat-icon>
    </div>
    <div class="report-name-container overflow-hidden">
      <div class="overflow-hidden">
        <div class="display-flex flex-column gap-0-5em">
          <div class="display-flex gap-0-5em flex-align-center overflow-hidden">
            <div class="report-name text-ellipsis"
                 [customToolTip]="report.payload.attributes.name"
                 [@enlargeText]="{
                value: enlargeText,
                params: {
                  fontWeight: 500,
                  fontSize: '1rem',
                  enlargeFontWeight: 700,
                  enlargeFontSize: '1.05rem'
                }
              }">
              {{ report.payload.attributes.name }}
            </div>
            <ng-container *ngIf="report.isFavorite$ | async">
              <mat-icon class="favorite-icon">star</mat-icon>
            </ng-container>
          </div>
          <app-report-badge-public class="mt-0-2rem"
                                   appClickStopPropagation
                                   [link]="report.publicUrl$ | async"
                                   *ngIf="report.isPublic$ | async"
                                   (click)="onPublic.emit()"></app-report-badge-public>
        </div>
      </div>
    </div>
    <div class="report-type-container">{{ 'reports.' + report.payload.attributes.report_type | translate }}</div>
    <div class="report-parameters-container">
      <app-report-table-row-parameters [report]="report"></app-report-table-row-parameters>
    </div>
    <div class="report-created-by-container">
      <app-user-badge [user]="report.owner$ | async"
                      *ngIf="report.owner$ | async"></app-user-badge>
    </div>
    <div class="report-actions-container">
      <ng-container *ngIf="report.parameters$ | async">
        <button mat-icon-button
                *ngIf="!showActions; else actions">
          <mat-icon class="icon-more">more_vert</mat-icon>
        </button>
      </ng-container>
      <ng-template #actions>
        <div class="report-actions-container"
             [@showSlideRight]="'show'">
          <button mat-icon-button
                  appClickStopPropagation
                  (click)="onInfo.emit()"
                  [customToolTip]="'reports.report_info' | translate">
            <mat-icon class="material-icons-outlined icon-information">info</mat-icon>
          </button>
          <button mat-icon-button
                  appClickStopPropagation
                  [customToolTip]="'reports.open_report_in_new_tab' | translate"
                  (click)="onOpenInNewTab.emit()">
            <mat-icon class="material-icons-outlined icon-new">open_in_new</mat-icon>
          </button>
        </div>
        <button mat-icon-button
                appClickStopPropagation
                [customToolTip]="'reports.open_report' | translate"
                (click)="onOpen.emit()">
          <mat-icon class="material-icons-outlined icon-done">chevron_right</mat-icon>
        </button>
      </ng-template>
    </div>
  </div>
</app-loader>
